import { InputAdornment } from '@cmg/design-system';
import type { FormikNumberFieldProps } from '@cmg/design-system-formik';
import {
  FormikCurrencyField,
  FormikNumberField,
  FormikPercentageField,
} from '@cmg/design-system-formik';
import defaultTo from 'lodash/defaultTo';
import isNil from 'lodash/isNil';
import { FC } from 'react';

import { InterestLevelInterestUnit } from '../../../../../../../../../graphql';

export type FormikInterestQuantityFieldProps = Readonly<{
  currencyCode: string | null;
  interestUnit: InterestLevelInterestUnit | null;
  endAdornmentOverride: string | null;
}> &
  Pick<
    FormikNumberFieldProps,
    'name' | 'disabled' | 'showHelperTextInTooltip' | 'fullWidth' | 'aria-label'
  >;

export const FormikInterestQuantityField: FC<FormikInterestQuantityFieldProps> = ({
  interestUnit,
  currencyCode,
  endAdornmentOverride,
  ...rest
}) => {
  const props = {
    ...rest,
    'aria-label': defaultTo(rest['aria-label'], 'interestQuantity'),
  };

  switch (interestUnit) {
    case InterestLevelInterestUnit.Currency:
      return <FormikCurrencyField {...props} currencyCode={defaultTo(currencyCode, undefined)} />;
    case InterestLevelInterestUnit.Percent:
      return <FormikPercentageField {...props} />;
    case InterestLevelInterestUnit.Shares:
      return (
        <FormikNumberField
          {...props}
          decimalScale={0}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end" disablePointerEvents>
                {isNil(endAdornmentOverride) ? 'SHs' : endAdornmentOverride}
              </InputAdornment>
            ),
          }}
        />
      );
    default:
      return <FormikNumberField {...props} />;
  }
};
